import { useRouter } from "vue-router";

export default () => {
  const router = useRouter();

  window.toLogin = () => {
    router.push("/login");
  };
};
